"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getContactPropertiesState = getContactPropertiesState;
exports.getRequestState = getRequestState;
exports.getProperties = getProperties;
exports.getLifecycleProperty = getLifecycleProperty;
exports.getGroups = getGroups;
exports.getCreationRequestState = getCreationRequestState;
exports.getCreateContactPropertyErrorMessage = getCreateContactPropertyErrorMessage;
exports.getContactPropertyGroupsByGroupName = getContactPropertyGroupsByGroupName;

function getContactPropertiesState(state) {
  return state.contactProperties;
}

function getRequestState(state) {
  return getContactPropertiesState(state).fetchRequestState;
}

function getProperties(state) {
  return getContactPropertiesState(state).properties;
}

function getLifecycleProperty(state) {
  return getProperties(state).find(function (p) {
    return p.name === 'lifecyclestage';
  });
}

function getGroups(state) {
  return getContactPropertiesState(state).groups;
}

function getCreationRequestState(state) {
  return getContactPropertiesState(state).creationRequestState;
}

function getCreateContactPropertyErrorMessage(state) {
  return getContactPropertiesState(state).creationErrorMessage;
}

function getContactPropertyGroupsByGroupName(state) {
  return getContactPropertiesState(state).groups;
}